import { useState, useEffect, memo } from "react";

export default memo(function EditableCell({ value, type = "number", onChange, disabled = false }) {
    const [localValue, setLocalValue] = useState(value ?? '');

    useEffect(() => {
        setLocalValue(value ?? '');
    }, [value]);

    return (
        <input
            type="text"
            inputMode={type === 'number' ? 'decimal' : 'text'}
            value={localValue}
            disabled={disabled}
            aria-label={`Edit ${type} value`}
            style={{
                width: '100%',
                height: 30,
                padding: '0 4px',
                fontSize: 13,
                border: 'none',
                borderBottom: '1px solid rgba(0,0,0,0.42)',
                background: 'transparent',
                outline: 'none',
                fontFamily: 'inherit',
            }}
            onFocus={(e) => { e.target.style.borderBottom = '2px solid #1976d2'; }}
            onBlurCapture={(e) => { e.target.style.borderBottom = '1px solid rgba(0,0,0,0.42)'; }}
            onChange={(e) => setLocalValue(e.target.value)}
            onClick={(e) => {
                e.stopPropagation();
                e.target.select();
            }}
            onBlur={(e) => {
                if (e.target.value !== String(value ?? '')) {
                    if (type === 'number') {
                        const num = Number(e.target.value);
                        onChange(e.target.value === '' ? null : (isNaN(num) ? null : num));
                    } else {
                        onChange(e.target.value);
                    }
                }
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.target.blur();
                }
            }}
        />
    );
});
